module.exports = __webpack_public_path__ + "img/gaji_sekarang.b88420e6.png";